export const GRAVITY_UAT_URL = 'https://gra-fe-gravity-uat.juliusbaer.com/gravity/';
export const GRAVITY_URL = 'https://gra-fe-gravity.juliusbaer.com/gravity/';

export const injectGravity = (username: string) => {
  const head = document.getElementsByTagName('head')[0];
  const script = document.createElement('script');
  const baseUrl = /-(uat|tst)/i.test(window.location.href) ? GRAVITY_UAT_URL : GRAVITY_URL;
  const options = { email: `${username}` };
  script.type = 'text/javascript';
  script.onload = () =>
    // @ts-expect-error pi.gravity is a global library
    pi.gravity.inject.setup(baseUrl, baseUrl + 'inject/', 'Static inject', options);
  script.src = baseUrl + 'inject/js/pi.gravity.inject.js';
  head.append(script);
};
